import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Title from "../../../Components/Title";

const useStyles = makeStyles((theme) => ({
  row: {
    lineHeight: "1.5em",
    height: "5.1em",
    cursor: "pointer",
  },
  loading: {
    display: "-webkit-box",
    overflow: "hidden",
    "-webkit-line-clamp": 3,
    "-webkit-box-orient": "vertical",
    fontSize: "20px",
  },
  content: {
    display: "-webkit-box",
    overflow: "hidden",
    "-webkit-line-clamp": 3,
    "-webkit-box-orient": "vertical",
  },
  count: {
    color: "#ee3333",
    whiteSpace: "nowrap",
  },
}));

export default function Keyword(props) {
  const classes = useStyles();

  const contents = () => {
    if (!props.isApiReturn) {
      return [...Array(10)].map((row, index) => (
        <TableRow key={index} className={classes.row}>
          <TableCell>{index + 1}</TableCell>
          <TableCell>
            <span className={classes.loading}>Loading...</span>
          </TableCell>
        </TableRow>
      ));
    } else {
      if (props.content.length > 0) {
        return props.content.map((row, index) => (
          <TableRow
            key={index}
            className={classes.row}
            onClick={() => props.handleClickRow(row.word)}
            hover
          >
            <TableCell>{index + 1}</TableCell>
            <TableCell>
              <span className={classes.content}>{row.word}</span>
            </TableCell>
            <TableCell className={classes.count}>{row.count}件</TableCell>
          </TableRow>
        ));
      } else {
        return [...Array(10)].map((row, index) => (
          <TableRow key={index} className={classes.row}>
            <TableCell>{index + 1}</TableCell>
            <TableCell>
              <span className={classes.content}>-</span>
            </TableCell>
            <TableCell className={classes.count}>-</TableCell>
          </TableRow>
        ));
      }
    }
  };

  return (
    <React.Fragment>
      <Title>キーワード</Title>
      <Table size="small">
        <TableBody>{contents()}</TableBody>
      </Table>
    </React.Fragment>
  );
}
